import React, { useEffect, useRef, useState, useCallback } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "./HomeSearch.scss";
import {
  Link,
  useLocation,
  useNavigate,
  useNavigationType,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import {
  getAirportCodes,
  getNonRelevantPackagesList,
  getPackages,
  getRecommendedPackages,
} from "../../redux/commonActionCreator";
import {
  airport_codes,
  package_loader,
  searchData,
  searchGuestData,
  updateRedux,
} from "../../redux/commonReducer";
import moment from "moment";
import { ThirtyDayFromStartDate } from "../../utils/helpers";
import { Spinner } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";

export const CounterItem = ({
  index,
  item,
  onCountChangeHandler,
  guestData,
}) => {
  const totalCount = guestData?.reduce((sum, person) => sum + person.count, 0);

  return (
    <div className="Item" key={index}>
      <div className="category">
        <h5>{item?.title}</h5>
        <p>{item?.ageRange}</p>
      </div>
      <div className="add-btn">
        <button
          type="button"
          onClick={() => onCountChangeHandler("sub", item, index)}
          disabled={item?.count === 0}
        >
          <img src="/assets/img/icons/subtract-minus.svg" alt="Subtract" />
        </button>
        <span>{item?.count}</span>
        <button
          type="button"
          onClick={() => onCountChangeHandler("add", item, index)}
          disabled={item?.count === 9 || totalCount >= 9}
        >
          <img src="/assets/img/icons/add-plus.svg" alt="Add" />
        </button>
      </div>
    </div>
  );
};

export default function HomeSearch({
  btnTitle,
  onSearch,
  duration,
  requested_days,
  page,
  scrollToSliderContent
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const navigationType = useNavigationType(); // "push", "replace", or "pop"

  const filterGridRef = useRef(null);



  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [showDiv, setShowDiv] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState(null);
  const [lastSearchTime, setLastSearchTime] = useState(0);

  const THROTTLE_TIME = 2000; // 2 seconds throttle time
  const DEBOUNCE_TIME = 500;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const airportCodesList = useSelector(airport_codes);
  const data = useSelector(searchData);
  const guestData = useSelector(searchGuestData);
  const loader = useSelector(package_loader);

  const [filter, setFilter] = useState("");
  const [err, setErr] = useState({});

  const [dateRange, setDateRange] = useState(
    data ? [data.start_date, data.end_date] : [null, null]
  );
  // const [startDate, endDate] = dateRange;
  const maxEndDate = ThirtyDayFromStartDate(new Date(data?.start_date));
  const startDate = ThirtyDayFromStartDate(new Date());

  useEffect(() => {
    if (data?.start_date && (duration || requested_days)) {
      let startDate = new Date(data.start_date);
      let days = requested_days ?? duration;
      console.log(days, "888888", requested_days, duration);
      if (!isNaN(startDate.getTime())) {
        let calculatedEndDate = new Date(
          startDate.getTime() + days * 24 * 60 * 60 * 1000 - 24 * 60 * 60 * 1000
        );
        dispatch(
          updateRedux({
            key: "searchData",
            value: {
              ...data,
              end_date: calculatedEndDate?.toISOString(),
            },
          })
        );
      }
    }
  }, [data?.start_date, requested_days]);

  useEffect(() => {
    if (navigationType == "POP") {
      setDateRange([]);
    }
  }, [navigationType]);

  const processedAirportCodesList = airportCodesList?.map((airport) => ({
    ...airport,
    airport_name: String(airport.airport_name),
    airport_code: String(airport.airport_code),
  }));

  const handleOpen = (e) => {
    if (!(e == "end_date" && data?.start_date == "")) {
      setFilter(e);
    }
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        filterGridRef.current &&
        !filterGridRef.current.contains(event.target)
      ) {
        handleOpen("");
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const triggerSearch = useCallback(() => {
    if (page === "detail") {
      onSearch ? onSearch() : onSearchHandler();
      setLastSearchTime(Date.now()); // Update last search time
    }
  }, [page, onSearch]);

  useEffect(() => {
    if (
      (Object.keys(data).length > 0 || Object.keys(guestData).length > 0) &&
      page === "detail"
    ) {
      const now = Date.now();
      if (now - lastSearchTime > THROTTLE_TIME) {
        triggerSearch();
      } else {
        if (debouncedSearch) clearTimeout(debouncedSearch);
        setDebouncedSearch(setTimeout(() => triggerSearch(), DEBOUNCE_TIME));
      }
    }
  }, [data, guestData]);

  const onChangeHandler = (key, value) => {
    dispatch(
      updateRedux({
        key: "searchData",
        value: {
          ...data,
          [key]: value,
        },
      })
    );
    if (key === "start_date") {
      const newEndDate =
        value && duration
          ? new Date(
            value.getTime() +
            duration * 24 * 60 * 60 * 1000 -
            24 * 60 * 60 * 1000
          )?.toISOString()
          : "";
      dispatch(
        updateRedux({
          key: "searchData",
          value: {
            ...data,
            start_date: value?.toISOString(),
            end_date: newEndDate,
          },
        })
      );
    }
  };

  const dateChangeHandler = (dates) => {
    const [start, end] = dates;
    dispatch(
      updateRedux({
        key: "searchData",
        value: {
          ...data,
          start_date: start,
          end_date: end ?? "",
        },
      })
    );
    setFilter("")
  };

  const onCountChangeHandler = (type, item, index) => {
    let arr = [...guestData];
    let obj = { ...arr[index] };
    obj.count =
      type == "add"
        ? Number(item?.count) + 1
        : Number(item?.count) > 0
          ? Number(item?.count) - 1
          : 0;
    arr[index] = obj;
    dispatch(
      updateRedux({
        key: "searchGuestData",
        value: arr,
      })
    );
    setFilter("")
  };

  const onSearchHandler = () => {
    if (data?.start_date) {
      if (!data?.end_date) {
        setErr({
          ...err,
          end_date: "Please select end date",
        });
      } else {
        setErr({
          ...err,
          end_date: "",
        });
        finalSearch();
      }
    } else {
      finalSearch();
    }
  };

  const finalSearch = () => {
    let commonData = {
      id: data?.departure?.[0]?._id ?? "",
      number_of_guest: {
        adults: guestData?.find((ele) => ele.key === "adults")?.count,
        age_5_12: guestData?.find((ele) => ele.key === "age_5_12")?.count,
        age_2_5: guestData?.find((ele) => ele.key === "age_2_5")?.count,
        age_less_2: guestData?.find((ele) => ele.key === "age_less_2")?.count,
      },
    };
    let searchData = {
      ...commonData,
      start_date: data?.start_date
        ? moment(data?.start_date).format("YYYY-MM-DD")
        : "",
      end_date: data?.end_date
        ? moment(data?.end_date).format("YYYY-MM-DD")
        : "",
    };
    let highRaw = {
      ...commonData,
      ...searchData,
      api_type:
        data?.start_date && data?.end_date
          ? "highly_recommended"
          : "self-drive",
    };
    dispatch(
      getPackages(highRaw, (res) => {
        localStorage.setItem("searchData", JSON.stringify(data));
        localStorage.setItem("searchGuestData", JSON.stringify(guestData));
        let raw = {
          ...commonData,
          ignoreIds:
            Number(res.data?.[0]?.days) !== Number(res.data?.[0]?.duration)
              ? []
              : res.data?.map((item, i) => item?._id),
          api_type: "non_relevant",
        };
        dispatch(getNonRelevantPackagesList(raw));
        let recommendedRaw = {
          ...commonData,
          ...searchData,
          api_type: "recommended",
          ignoreIds: res.data?.map((item, i) => item?._id),
        };
        dispatch(getRecommendedPackages(recommendedRaw));
        if (data?.start_date && data?.end_date) {
          navigate("/search");
        } else {
          navigate("/self-drive");
        }
      })
    );
  };

  const handleSearch = (searchTerm) => {
    let raw = {
      keyword: searchTerm,
    };
    dispatch(getAirportCodes(raw));
  };

  return (
    (
      <>
        <div className="search__area">
          {isMobile && location?.pathname == "/" && (
            <div className="mobile__btn">
              <button
                className={`${"search_flight_btn"} ${showDiv ? "close" : ""}`}
                onClick={() => setShowDiv(!showDiv)}
              >
                {" "}
                {!showDiv ? (
                  <img src="/assets/img/icons/search.svg" alt="" />
                ) : (
                  <img src="/assets/img/icons/close.svg" alt="" />
                )}{" "}
                {!showDiv ? "Search Experiences" : ""}
              </button>
            </div>
          )}
          {showDiv || !isMobile || location?.pathname != "/" ? (
            <div className="search__home">
              {[
                {
                  id: "departure",
                  icon: "departure",
                  label: "Departure",
                  value: data?.departure?.length
                    ? // ? `${data?.departure?.airport_name} (${data?.departure?.airport_code})`
                    `${data?.departure?.[0]?.airport_city} (${data?.departure?.[0]?.airport_code})`
                    : "Select Departure",
                },
                {
                  id: "start_date",
                  icon: "arrival",
                  label: "Start Date",
                  value: data?.start_date ? (
                    <>
                      {/* {moment(data?.start_date).format("MMM D")}
                  <sup>
                    {moment(data?.start_date)
                      .format("Do")
                      .replace(/\d+/g, "")
                      .trim()}
                  </sup>
                  , {moment(data?.start_date).format("YYYY")} */}
                      {moment(data?.start_date).format("DD MMM YY")}
                    </>
                  ) : (
                    "Select Date"
                  ),
                },
                {
                  id: "end_date",
                  icon: "arrival",
                  label: "End Date",
                  value: data?.end_date ? (
                    <>
                      {/* {moment(data?.end_date).format("MMM D")}
                  <sup>
                    {moment(data?.end_date)
                      .format("Do")
                      .replace(/\d+/g, "")
                      .trim()}
                  </sup>
                  , {moment(data?.end_date).format("YYYY")} */}
                      {moment(data?.end_date).format("DD MMM YY")}
                    </>
                  ) : (
                    "Select Date"
                  ),
                },
                {
                  id: "guests",
                  icon: "guests",
                  label: "Guests",
                  value: guestData.reduce(
                    (sum, person) => sum + person.count,
                    0
                  ),
                },
              ].map(({ id, icon, label, value }) => (
                <div
                  className="grid"
                  key={id}
                  onClick={() => handleOpen(id)}
                  style={{
                    cursor:
                      id == "end_date" && data?.start_date == ""
                        ? "text"
                        : "pointer",
                  }}
                >
                  <div className="title">
                    <div className="icon">
                      <img src={`/assets/img/icons/${icon}.svg`} alt={label} />
                    </div>
                    <h6>
                      {label}{" "}
                      <img
                        src="/assets/img/icons/dropdown.svg"
                        alt="Dropdown"
                      />
                    </h6>
                  </div>
                  <h4>{value}</h4>
                </div>
              ))}
              <div className="grid">
                <button
                  className="btn btn-primary search"
                  onClick={() => {
                    if(scrollToSliderContent){
                      scrollToSliderContent()
                    }
                    
                    setTimeout(()=> onSearch ? onSearch() : onSearchHandler(), 500)
                  }}
                  disabled={loader}
                  style={{ textWrap: "nowrap" }}
                >
                  {!btnTitle ? "Let's Go!" : btnTitle}
                  {loader && <Spinner animation="border" />}
                </button>
                <small id="error" className="error">
                  {err?.end_date}
                </small>
              </div>
            </div>
          ) : (
            ""
          )}
          {["departure", "start_date", "end_date", "guests"].includes(
            filter
          ) && (
              <div
                className="filterGrid"
                style={{
                  left:
                    filter === "departure"
                      ? "0%"
                      : filter === "start_date"
                        ? "19%"
                        : filter === "end_date"
                          ? "37%"
                          : filter === "guests"
                            ? "56%"
                            : null,
                }}
                ref={filterGridRef}
              >
                {isMobile && (
                  <div
                    className="mobile_close_search"
                    onClick={() => handleOpen("")}
                  >
                    <img src="/assets/img/icons/close.svg" alt="" />
                  </div>
                )}

                {filter === "departure" ? (
                  <>
                    <h4>
                      <img src={`/assets/img/icons/arrival.svg`} /> Select
                      departure
                    </h4>
                    <AsyncTypeahead
                      id="flight-search"
                      labelKey={(option) =>
                        `${option.airport_name} (${option.airport_code})`
                      }
                      renderMenuItemChildren={(option) => (
                        <div>
                          {`${option.airport_name} (${option.airport_code})`}
                        </div>
                      )}
                      minLength={2}
                      options={processedAirportCodesList} // Use preprocessed list
                      onSearch={handleSearch}
                      selected={data?.departure}
                      onChange={(e) => {
                        onChangeHandler("departure", e);
                        if (e?.length !== 0) {
                          setTimeout(() => {
                            handleOpen("");
                          }, 500);
                        }
                      }}
                      placeholder="Flying from"
                      className="flight_search"
                    />
                    {/* <button className="btn-primary mt-2 w-100 justify-content-center">Continue</button> */}
                  </>
                ) : filter === "start_date" ? (
                  <>
                    <h4>
                      <img src={`/assets/img/icons/arrival.svg`} /> Start Date
                    </h4>
                    <DatePicker
                      selectsRange={true}
                      selected={data?.start_date}
                      placeholderText="Start Date"
                      minDate={startDate}
                      // onChange={(update) => {
                      //   onChangeHandler("start_date", update);
                      // }}
                      onChange={dateChangeHandler}
                      isClearable={true}
                      inline
                      startDate={data?.start_date ?? startDate}
                      endDate={data?.end_date}
                    // maxDate={maxEndDate}
                    />
                  </>
                ) : filter === "end_date" ? (
                  <>
                    <h4>
                      <img src={`/assets/img/icons/arrival.svg`} /> End Date
                    </h4>
                    <DatePicker
                      selectsEnd
                      selected={data?.end_date}
                      onChange={(update) => {
                        if (update) {
                          setFilter("")
                          let a = moment(update);
                          let b = moment(data?.start_date);
                          let diff = a.diff(b, "days") + 1;
                          if (duration > diff) {
                            let new_date = moment(update[0], "DD-MM-YYYY").add(
                              duration,
                              "days"
                            );
                            onChangeHandler("end_date", new Date(new_date));
                            toast.error(
                              `The package duration is ${duration} days. Please select a date that is at least ${duration} days from the start date.`,
                              {
                                position: "bottom-center",
                                autoClose: 3000,
                              }
                            );
                          } else {
                            onChangeHandler("end_date", update);
                          }
                        }
                      }}
                      startDate={data?.start_date}
                      minDate={
                        data?.start_date && duration
                          ? new Date(
                            new Date(data?.start_date)?.getTime() +
                            duration * 24 * 60 * 60 * 1000 -
                            24 * 60 * 60 * 1000
                          )
                          : data?.start_date ?? startDate
                      }
                      placeholderText="End Date"
                      maxDate={maxEndDate}
                      inline
                      disabled={!data?.start_date}
                      selectsDisabledDaysInRange
                    />
                  </>
                ) : (
                  <div className="guests">
                    {guestData.map((item, index) => (
                      <CounterItem
                        index={index}
                        item={item}
                        onCountChangeHandler={onCountChangeHandler}
                        guestData={guestData}
                      />
                    ))}
                  </div>
                )}
              </div>
            )}
        </div>
      </>
    )
  );
}
